import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { PrismDataSource } from '../models/prism-data-source.model';
import { GlobalFilterService } from '../services/global-filter.service';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { HomeComponent } from './home.component';

const moduleroutes: Routes = [
    {
        path: 'home',
        component: HomeComponent,
        children: [
            { path: '', redirectTo: '/home/welcome', pathMatch: 'full', canActivate: [AuthGuard] },
            { path: 'welcome', component: WelcomeComponent, canActivate: [AuthGuard] },
        ],
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(moduleroutes),
    ],
    declarations: [
        WelcomeComponent,
    ],
    providers: [],
})
export class HomeModule {
 }



// WEBPACK FOOTER //
// ./src/app/home/home.module.ts